export default "__VITE_ASSET__UE6qImVb__"